import { OnInit, Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './rawmaterials-multi-edit-size-limit.dialog.html'
})
export class NeqRawmaterialsMultiEditSizeLimitDialogComponent implements OnInit {

  public message: string;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqRawmaterialsMultiEditSizeLimitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string}
  ) {
  }

  ngOnInit() {
    this.message = this.data.message;
  }

  close() {
    this.dialogRef.close();
  }
}
